import $api from "..";
import { AxiosResponse } from "axios";
import { ITaskEdit } from "../common/api_interfaces/task/ITaskEdit";
import { ITag } from "../common/api_interfaces/tag/ITag";
import { ITagFromDisplay } from "../common/api_interfaces/tag/ITagFromDisplay";
import { IProjectHistoryDisplay } from "../common/api_interfaces/history/IProjectHistoryDisplay";
import { ITaskChecklistGroup } from "../common/api_interfaces/taskChecklist/ITaskChecklistGroup";
import { ITaskChecklistGroupEdit } from "../common/api_interfaces/taskChecklist/ITaskChecklistGroupEdit";
import { ITaskChecklist } from "../common/api_interfaces/taskChecklist/ITaskChecklist";
import { ITaskChecklistEdit } from "../common/api_interfaces/taskChecklist/ITaskChecklistEdit";
import { ISetTaskParent } from "../common/api_interfaces/task/ISetTaskParent";
import { IMessageActions } from "../common/api_interfaces/actions/IMessageActions";
import { ITaskFormDisplay } from "../common/api_interfaces/task/ITaskFormDisplay";
import { ITaskGeneralInfo } from "../common/api_interfaces/task/ITaskGeneralInfo";
import { IGetTaskRequest } from "../common/api_interfaces/task/IGetTaskRequest";
import { IGetTaskHistoryDisplay } from "../common/api_interfaces/history/IGetTaskHistoryDisplay";
import { ITaskCreate } from "../common/api_interfaces/task/ITaskCreate";
import { IDeleteTasks } from "../common/api_interfaces/task/IDeleteTasks";
import { IGetTasksDisplayData } from "../common/api_interfaces/task/IGetTasksDisplayData.request";
import { ITasksDisplay } from "../common/api_interfaces/task/ITaskDisplay.response";
import { IGetAllTaskPerson } from "../common/api_interfaces/task/IGetAllTaskPerson";
import { ITasksUpdateDates } from "../common/api_interfaces/task/ITasksUpdateDates";
import { ITypeAndPriority } from "../common/api_interfaces/task/ITypeAndPriority";
import { ICreateTegTask } from "../common/api_interfaces/tag/ICreateTegTask";
import { ISubTaskView } from "../common/api_interfaces/task/ISubTaskView";
import { ISubTask } from "../common/api_interfaces/task/ISubTask";

export default class TaskService {
    async getProjectTasksDisplayData(body: IGetTasksDisplayData): Promise<AxiosResponse<ITasksDisplay>> {
        return $api.post<ITasksDisplay>(`Project/getTasks`, body);
    }

    async getAllTaskPerson(taskId: number): Promise<AxiosResponse<IGetAllTaskPerson>> {
        return $api.get<IGetAllTaskPerson>(`Task/getAllTaskPerson?taskId=${taskId}`);
    }

    async getTypeAndPriority(): Promise<AxiosResponse<ITypeAndPriority>> {
        return $api.get<ITypeAndPriority>(`Project/getTypeAndPriority`);
    }

    async getTask(reqBody: IGetTaskRequest): Promise<AxiosResponse<ITaskGeneralInfo>> {
        return $api.post<ITaskGeneralInfo>(`Project/getTaskInfo`, reqBody);
    }

    async getTaskHistory(reqBody: IGetTaskHistoryDisplay): Promise<AxiosResponse<IProjectHistoryDisplay[]>> {
        return $api.post<IProjectHistoryDisplay[]>(`Project/getTaskLogs`, reqBody);
    }

    async getTaskForm(taskId: number): Promise<AxiosResponse<ITaskFormDisplay>> {
        return $api.get<ITaskFormDisplay>(`Project/getTask?taskId=${taskId}`);
    }
    async addTeg(body: ICreateTegTask): Promise<AxiosResponse<number>> {
        return $api.post<number>(`teg/addTeg`, body);
    }
    async addTegTask(body: ICreateTegTask): Promise<AxiosResponse<number>> {
        return $api.post<number>(`teg/addTegTaskInfo`, body);
    }

    async getTegs(body: {
        taskId: number | undefined;
        projectId: number | undefined;
        userId: number;
    }): Promise<AxiosResponse<ITag[]>> {
        return $api.post<ITag[]>(`teg/getTegs`, body);
    }

    async deleteTasks(body: IDeleteTasks): Promise<void> {
        return $api.post("Project/deleteTasks", body);
    }

    async createTask(body: ITaskCreate): Promise<AxiosResponse<ITaskFormDisplay>> {
        return $api.post("Project/addTask", body);
    }

    async editTask(body: ITaskEdit): Promise<void> {
        return $api.post("Project/editTask", body);
    }

    async addTagsInTasks(body: ITagFromDisplay): Promise<void> {
        return $api.post("Task/addTagsInTasks", body);
    }

    async removeTagsInTasks(body: ITagFromDisplay): Promise<void> {
        return $api.post("Task/removeTagsInTasks", body);
    }

    async getTaskChecklist(taskId: number): Promise<AxiosResponse<ITaskChecklistGroup[] | []>> {
        return $api.get(`Task/getTaskChecklist?taskId=${taskId}`);
    }

    async createChecklistGroup(body: ITaskChecklistGroup) {
        return $api.post("Task/addChecklistGroup", body);
    }

    async editChecklistGroup(body: ITaskChecklistGroupEdit) {
        return $api.post("Task/editChecklistGroup", body);
    }

    async deleteTaskChecklistGroup(groupId: number) {
        return $api.get(`Task/deleteTaskChecklistGroup?groupId=${groupId}`);
    }

    async createChecklistElement(body: ITaskChecklist) {
        return $api.post("Task/addChecklistElement", body);
    }
    async deleteTaskChecklistElement(elementId: number) {
        return $api.get(`Task/deleteElementTaskChecklist?elementId=${elementId}`);
    }

    async editTaskChecklistElement(body: ITaskChecklistEdit) {
        return $api.post("Task/editChecklistElement", body);
    }

    async getSubTasksTree(taskId: number): Promise<AxiosResponse<ISubTaskView>> {
        return $api.get<ISubTaskView>(`Task/getSubTasksTree?taskId=${taskId}`);
    }

    async getAvailableSubTasks(taskId: number): Promise<AxiosResponse<ISubTask[]>> {
        return $api.get(`Task/getAvailableSubTasks?taskId=${taskId}`);
    }

    setTaskParent(body: ISetTaskParent): Promise<AxiosResponse<void>> {
        return $api.post("Task/setParent", body);
    }
    async updateTaskDates(body: ITasksUpdateDates): Promise<AxiosResponse<void>> {
        return $api.post("/Project/updateTaskDates", body);
    }

    executeActions(body: IMessageActions): Promise<AxiosResponse<void>> {
        return $api.post(`/Task/executeTaskActions`, body)
    }
}
